import React from 'react'
import s from './ProfileItemsSection.module.scss'
import ProfileItemCard from '../../Components/ProfileItemCard/ProfileItemCard'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'

const ProfileItemsSection = ({
	title,
	color,
	items = [],
	headerIcon,
	cardIcon,
	emptyText,
	isLoading = false,
}) => {
	const hasItems = Array.isArray(items) && items.length > 0

	if (!isLoading && !hasItems && !emptyText) {
		return null
	}

	return (
		<section className={`${s.card} ${color ? s[`card--${color}`] : ''}`}>
			<div className={s.head}>
				<span
					className={`${s.head__icon} ${
						color ? s[`head__icon--${color}`] : ''
					}`}
				>
					{headerIcon}
				</span>
				<h3 className={s.head__title}>
					{title} {!isLoading && hasItems ? `(${items.length})` : ''}
				</h3>
			</div>

			<div className={s.list}>
				{isLoading ? (
					<span className={`${s.loader} ${s.loaderRow}`}>
						<LoaderImg />
					</span>
				) : hasItems ? (
					items.map(item => (
						<ProfileItemCard
							key={item.id}
							color={color}
							icon={cardIcon}
							{...item}
						/>
					))
				) : (
					<p className={s.empty}>{emptyText}</p>
				)}
			</div>
		</section>
	)
}

export default ProfileItemsSection
